import BaseController    from "controllers/backend/base"

class Controller extends BaseController {
  call() {
    super.call();
    questionCharacterCount.call(this)
    optionsCharacterCount.call(this)
  }
};

let questionCharacterCount = function() {
  $('.question-container').on('keyup', () => {
    let question = $('#poll_question');
    let characters = $('#poll_question').val().split('');
    let wordCount = $('#word-count');

    wordCount.html(144 - characters.length);
    if (characters.length > 144) {
      $('#poll_question').val(question.val().substring(0,144))
      wordCount.html(0);
    }
  });
}

let optionsCharacterCount = function() {
  this.root.on('keyup', '.poll-option-response', (e) => {
    let response = e.target;
    let wordCount = $(response).parents('.poll-option-response').find('.option-word-count')
    let characters = response.value;

    wordCount.html(30 - characters.length);
    if (characters.length > 30) {
      response.value = response.value.substring(0,30);
      wordCount.html(0);
    }
  });
}

export default Controller;
